import { CarserviceEstimate } from './../model/car-service-estimate';
export class CarServiceEstimateBuilder {
    static buildCarServiceEstimate(data) {
        const carServiceEstimate = new CarserviceEstimate();
        carServiceEstimate.id_car_service = data.id_car_service;
        carServiceEstimate.id_mechanical_estimate = data.id_mechanical_estimate;
        carServiceEstimate.name = data.name;
        carServiceEstimate.name_es = data.name_es;
        carServiceEstimate.name_ca = data.name_ca;
        carServiceEstimate.name_fr = data.name_fr;
        carServiceEstimate.name_en = data.name_en;
        carServiceEstimate.description = data.description;
        carServiceEstimate.id_vehicle = data.id_vehicle;
        carServiceEstimate.date_requested = data.date_requested;
        carServiceEstimate.request_data = data.request_data;
        carServiceEstimate.mechanical_estimate_data = data.mechanical_estimate_data;
        carServiceEstimate.checksum = data.checksum;
        carServiceEstimate.gt_original_data = data.gt_original_data;
        carServiceEstimate.lang = (data.lang) ? data.lang : 'es';
        return carServiceEstimate;
    }
}
//# sourceMappingURL=car-service-estimate-builder.js.map